var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimeCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.833984 8.4987C0.833984 4.54066 4.04261 1.33203 8.00065 1.33203C11.9587 1.33203 15.1673 4.54066 15.1673 8.4987C15.1673 12.4567 11.9587 15.6654 8.00065 15.6654C4.04261 15.6654 0.833984 12.4567 0.833984 8.4987ZM8.50033 5.83268C8.50033 5.55654 8.27647 5.33268 8.00033 5.33268C7.72418 5.33268 7.50033 5.55654 7.50033 5.83268V8.32095C7.50033 8.59958 7.63958 8.85978 7.87141 9.01433L9.72297 10.2487C9.95274 10.4019 10.2632 10.3398 10.4164 10.11C10.5695 9.88027 10.5074 9.56983 10.2777 9.41666L8.50033 8.23176V5.83268Z",
    fill: "#6FBE45"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeCircle);
export default __webpack_public_path__ + "static/media/time-circle.eb4075cee32de0702c3f2fe85e706d47.svg";
export { ForwardRef as ReactComponent };